export enum WorkflowStatusType {
  Draft = 1,
  Validated = 2,
  Published = 3
}
